module.exports = __webpack_public_path__ + "img/no_history.9e4431b2.png";